module.exports = __webpack_public_path__ + "media/images/logo_facebook-6a6a717484d59ae533e6e9b34d406f38.png";